import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker';
import logout from '../../Global/logout';

export default async function DeleteTaxRate(   
   clientUuid,
   rateUuid,
   countryUuid
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }
    
    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/taxRate/'+ rateUuid + '?countryUuid=' + countryUuid, {
            method: 'delete',
            headers: { 'Authorization' : unHashedJwt}           
        }).then(res => res)
        .catch(error => error.response.data)
    );
}